// src/services/index.ts
import axios from 'axios';

let isHandlingError = false;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: (status) => {
    if (status === 401 && !isHandlingError) {
      isHandlingError = true;
      handleAuthError();
      return false;
    }
    return status >= 200 && status < 500;
  },
});

const handleAuthError = () => {
  localStorage.removeItem('authToken');
  redirectTo('/auth');
};

const handleNetworkError = () => {
  const currentPath = window.location.pathname;
  if (!['/auth', '/network-error'].includes(currentPath)) {
    localStorage.setItem('lastPath', window.location.pathname + window.location.search);
  }
  redirectTo('/network-error');
};

const redirectTo = (path: string) => {
  setTimeout(() => {
    window.location.href = path;
    isHandlingError = false;
  }, 100);
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (!error.response && !isHandlingError) {
      isHandlingError = true;
      handleNetworkError();
    }
    return Promise.reject(error);
  }
);

export default api;
